import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	assignedTeamLabel: {
		id: 'eoc.heartbeats.form.assigned-team-label.no-translate',
		defaultMessage: 'Assigned team',
		description: 'Label of assigned team field.',
	},
	assignedTeamErrorText: {
		id: 'eoc.heartbeats.form.assigned-team-error-text.no-translate',
		defaultMessage: 'Enter assigned team.',
		description: 'Error text of the assigned team field.',
	},
});

export default messages;
